import type { AImageProps } from '../../atoms/AImage/AImage.types';
import type { AScrimGradientProps } from '../../atoms/AScrimGradient/AScrimGradient.types';
import type { MTextBlockFullProps } from '../../molecules/MTextBlockFull/MTextBlockFull.types';
import type { MButtonProps } from '../../molecules/MButton/MButton.types';
import type { MMediaStackProps } from '../../molecules/MMediaStack/MMediaStack.types';
import { MMediaStackImageLayout } from '../../molecules/MMediaStack/MMediaStack.types';
import { TrackingPropsInterface } from '../../utils/enums/enums';

export enum OEditorialHighlightOverlay {
  Dark = 'Dark',
  Light = 'Light',
  None = 'None',
}

/** @deprecated Use MMediaStackImageLayout from MMediaStack instead */
export { MMediaStackImageLayout as OEditorialHighlightImageLayout } from '../../molecules/MMediaStack/MMediaStack.types';

export enum OEditorialHighlightContentAlignment {
  Centered = 'Centered',
  Left = 'Left',
  Right = 'Right',
}

export interface OEditorialHighlightTrackingProperties extends TrackingPropsInterface {
  leftArrowDesc?: string;
  cardLocation?: string;
  rightArrowDesc?: string;
  description?: string;
}

export interface OEditorialHighlightProps extends React.HTMLAttributes<HTMLDivElement> {
  overlay?: OEditorialHighlightOverlay;
  imageLayout?: MMediaStackImageLayout;
  contentAlignment?: OEditorialHighlightContentAlignment;
  container?: string;
  aImage?: AImageProps;
  aScrimGradient?: AScrimGradientProps;
  mTextBlockFull?: MTextBlockFullProps;
  mButton?: MButtonProps;
  mMediaStack?: MMediaStackProps;
  trackingProperties?: OEditorialHighlightTrackingProperties;
  className?: string;
  styleclass?: string;
}

export type { AImageProps, AScrimGradientProps, MTextBlockFullProps, MButtonProps, MMediaStackProps };
